import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

export enum SwipeDirection {
  Right = 'swiperight',
  Left = 'swipeleft',
}

@Component({
  selector: 'app-tab',
  template: `
    <div [hidden]="!active" class="pane" (swipeleft)="swipe.emit($event.type)"
         (swiperight)="swipe.emit($event.type)">
      <ng-content></ng-content>
    </div>
  `,
})
export class TabComponent {
  @Input() title: string;
  @Input() active = false;
  @Input() id;
  @Output() swipe = new EventEmitter<SwipeDirection>();
}
